import React from 'react';
import { connect } from 'react-redux';
import { fromJS, Map, Set, List } from 'immutable';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { goBack, MainComponentBox, locationFallThrough } from '../../../../util/util.jsx';
import { createFormData } from '@/util/util.jsx';
import AtomsQuantity from '../AtomsQuantity.jsx';
import Atoms from '../Atoms.jsx';
import { getDealListWrapper } from '../store/DealsWrapper.js';
import { handleFormChanged } from '@/store/allaround.store.js';
import { alterProduct } from '../store/deal.store.js';
import { saveSelectedAtoms } from '@/store/links.store.js';
import PackingNameDisplayWrapper from '@/component/dict/simple/packing/NameDisplayWrapper';
import DTNameDisplayWrapper from '@/component/dict/simple/deliveryterm/NameDisplayWrapper';
import { LinkHeader } from './LinkHeader';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import { REF_NAME as DT_REF_NAME,
  REF_PATH as DT_REF_PATH } from '@/component/dict/simple/deliveryterm/Const';
import { formPortString, threeSideValidation } from './LinkValidationFuncs.js';
import { formatRange } from '../elements/BaseElement.jsx';
import ElementBuilder from '../elements/ElementBuilder.jsx';
import { linkCreated } from '../../../../store/links.store';
export function validate(dealId, product, otherProduct, dealTo, dealFrom,
  deliveryTerms, transport) {
  const hostPorts = Array.isArray(product.get('ports')) ?
    new List().merge(product.get('ports')) :
    // eslint-disable-next-line
        product.get('ports',List());

  const otherPorts = Array.isArray(otherProduct.get('ports')) ?
    new List().merge(otherProduct.get('ports')) :
    // eslint-disable-next-line
        otherProduct.get('ports', List());

    // Date validation
  let hostDateFrom = product.get('shipmentFrom');
  let hostDateTo = product.get('shipmentTo');
  hostDateFrom = hostDateFrom ? new Date(`${hostDateFrom} 00:00:00`) : undefined;
  hostDateTo = hostDateTo ? new Date(`${hostDateTo} 23:59:59`) : undefined;
  let otherDateFrom = otherProduct.get('shipmentFrom');
  let otherDateTo = otherProduct.get('shipmentTo');
  otherDateFrom = otherDateFrom ? new Date(`${otherDateFrom} 00:00:00`) : undefined;
  otherDateTo = otherDateTo ? new Date(`${otherDateTo} 23:59:59`) : undefined;
  let dateAlert = '';
  if (!((hostDateFrom && hostDateTo) || (otherDateFrom && otherDateTo))) {
    dateAlert = (<div id="shipment_warning">
      <Row>
        <Col xs={12}>
          Shipment period is not set
        </Col>
      </Row>
    </div>);
  } else if ((hostDateTo && hostDateFrom && !(otherDateTo && otherDateFrom)) ||
      (!(hostDateTo && hostDateFrom) && otherDateTo && otherDateFrom)) {
    dateAlert = (<div id="shipment_warning">
      <Row>
        <Col xs={12}>
          Shipment period for
          the {hostDateTo && hostDateFrom ? dealTo : dealFrom} is not set
        </Col>
      </Row>
    </div>);
  } else if (hostDateFrom && hostDateTo && otherDateFrom && otherDateTo &&
         !(hostDateFrom >= otherDateFrom && hostDateFrom <= otherDateTo ||
           otherDateFrom >= hostDateFrom && otherDateFrom <= hostDateTo)
  ) {
    dateAlert = (<div id="shipment_warning">
      <Row>
        <Col xs={12}>
        Shipment dates mismatch
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {formatRange(product.get('shipmentFrom'), product.get('shipmentTo'))} vs.
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {formatRange(otherProduct.get('shipmentFrom'), otherProduct.get('shipmentTo'))}
        </Col>
      </Row>
    </div>);
  }
  // Packing validation
  let packingAlert = '';
  const toPacking = otherProduct.get('packing');
  const fromPacking = product.get('packing');

  const fromTransportType = product.get('transportType');
  const toTransportType = otherProduct.get('transportType');
  let transportTypeAlert = '';
  if (fromTransportType && toTransportType) {
    if (fromTransportType != toTransportType) {
      transportTypeAlert = (<Row style={{ marginBottom: '8px' }} id="transport_type_warning">
        <Col xs={12}>{`Transport type mismatch: ${fromTransportType} vs. ${toTransportType}`}</Col>
      </Row>);
    }
  }
  if (!(toPacking || fromPacking)) {
    packingAlert =
        (<Row style={{ marginBottom: '8px' }} id="packing_warning">
          <Col xs={12}>Packings are not set</Col>
        </Row>);
  } else if ((!toPacking && fromPacking) || (toPacking && !fromPacking)) {
    packingAlert =
        (<Row style={{ marginBottom: '8px' }} id="packing_warning">
          <Col xs={12}>
            Packing for the {!toPacking ? dealTo : dealFrom} is not set
          </Col>
        </Row>);
  } else if (toPacking != fromPacking) {
    packingAlert =
        (<Row style={{ marginBottom: '8px' }} id="packing_warning">
          <Col xs={12}>
            <Row>
              <Col xs={12}>Packing mismatch</Col>
            </Row>
            <Row>
              <Col xs={12}>
                <PackingNameDisplayWrapper
                  id={product.get('packing')}
                /> vs.
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <PackingNameDisplayWrapper
                  id={otherProduct.get('packing')}
                />
              </Col>
            </Row>
          </Col>
        </Row>);
  }

  // Port validation
  let portAlert = '';
  const threeSideValidationResult = threeSideValidation(deliveryTerms,
    dealFrom == 'purchase' ? product : otherProduct,
    dealFrom != 'purchase' ? product : otherProduct,
    transport);
  if (threeSideValidationResult !== false) {
    portAlert = threeSideValidationResult;
  } else {
    const hostDT = product.get('deliveryTerm');
    if (hostDT && hostDT === otherProduct.get('deliveryTerm')) {
      if (hostPorts.filter(port => otherPorts.indexOf(port) > -1).size === 0) {
        portAlert = (<div style={{ marginBottom: '8px' }} id="port_warning">
          <Row>
            <Col xs={12}>
              {'The purchase and the sale have the same Delivery term: '}
              <DTNameDisplayWrapper
                id={otherProduct.get('deliveryTerm')}
              />.
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
            However the ports mismatch
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
            Discharge ports: {dealFrom != 'purchase' ?
                formPortString(hostPorts) : formPortString(otherPorts)
              }
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
            Loading ports: {dealFrom == 'purchase' ?
                formPortString(hostPorts) : formPortString(otherPorts)
              }
            </Col>
          </Row>
        </div>);
      }
    }
  }
  return (packingAlert || portAlert || dateAlert) ? <div>
    {packingAlert}
    {transportTypeAlert}
    {portAlert}
    {dateAlert}
  </div> : undefined;
}

class AtomLinksEdit extends React.Component {
  constructor(props) {
    super(props);
    this.stepForward = this.stepForward.bind(this);
    this.stepBack = this.stepBack.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.findParentAtom = this.findParentAtom.bind(this);
    this.createParentAtom = this.createParentAtom.bind(this);
    this.alerts = {};
    const products = this.createFilter(props);
    this.state = ({ step: 1, disabled: true, products });
  }

  componentWillMount() {
    getDealListWrapper(this.props.dealTo);
    getDealListWrapper(this.props.dealFrom);
    getSimpleListWrapper(DT_REF_NAME, DT_REF_PATH);
    this.props.saveSelectedAtoms(new Map());
    locationFallThrough('New link', '', 'DEAL_LINK', this.stepBack);
    this.findParentAtom();
  }

  componentWillReceiveProps(props) {
    if (props.product && props.product != this.props.product) {
      const products = this.createFilter(props);
      this.setState({ products });
    }
    this.findParentAtom();
  }
  createFilter(props) {
    if (props.product) {
      return new Map({
        product: props.product.get('product'),
        shipment:
          [props.product.get('shipmentFrom'), props.product.get('shipmentTo')],
      });
    } return undefined;
  }
  handleSelected(domElemId, dealid, atom, productDomElemId) {
    let atoms = this.props.selectedAtoms;
    const id = atom.get('id');
    if (atoms.has(dealid)) {
      let values = atoms.get(dealid);
      if (values.has(id)) {
        values = values.delete(id);
        this.alerts[`${productDomElemId}`] = undefined;
      } else {
        this.alerts[`${productDomElemId}`] = validate(dealid, this.props.product,
          atom, this.props.dealTo, this.props.dealFrom, this.props.deliveryTerms);
        values = values.add(id);
      }
      atoms = atoms
        .delete(dealid)
        .set(dealid, values);
    } else {
      this.alerts[`${productDomElemId}`] = validate(dealid, this.props.product,
        atom, this.props.dealTo, this.props.dealFrom, this.props.deliveryTerms);
      const values = new Set()
        .add(id);
      atoms = atoms
        .set(dealid, values);
    }

    this.props.saveSelectedAtoms(atoms);

    let count = 0;
    atoms.forEach((products) => {
      count += products.size;
    });

    this.setState({ disabled: count === 0 });
  }

  stepBack() {
    if (this.state.step === 1) {
      this.props.stopAtomsLinking();
    } else {
      this.alerts = {};
      this.setState({ step: 1 });
    }
  }

  stepForward() {
    if (this.state.step === 1) {
      this.setState({ step: 2 });
    } else {
      let links = new List();
      // сохраняем все, что навыбирали
      this.props.selectedAtoms.forEach((atomids, dealid) => {
        links = this.composeLinks(links, dealid, atomids);
      });
      if (this.props.multiNodalQuantity) {
        links = links.map(l => l.set('fromMultiNodal', true)
          .set('multiNodalQuantity', this.props.multiNodalQuantity));
      }
      this.props.handleFormChanged();
      let productLinks = this.props.product.get(`${this.props.dealFrom}Link`) || new List();
      productLinks = productLinks.concat(links);
      this.props.alterProduct(
        this.props.productToLinkIdx,
        this.props.product.set(`${this.props.dealFrom}Link`,
          productLinks)
      );
      this.props.linkCreated(this.props.dealFrom, this.props.productToLinkIdx, links, productLinks);
      this.props.stopAtomsLinking();
    }
  }

  composeLinks(links, dealid, atomids) {
    let newLinks = links;
    atomids.forEach((atomid) => {
      const formData = createFormData(`edit_quantity_${dealid}_${atomid}`);
      formData.noTransportBl = formData.noTransportBl === 'on';
      // если пустое значение то нет этого свойства
      formData.billLadingDate = formData.billLadingDate;
      const newLink = fromJS(formData)
        .set(this.props.dealFrom, dealid)
        .set(`${this.props.dealFrom}Product`, this.props.product.get('id'))
        .set(`${this.props.dealFrom}ProductType`, this.props.product.get('productType'));
      newLinks = newLinks.push(newLink);
    });
    return newLinks;
  }

  hideAlert() {
    this.setState({ showAlert: false, alertMsg: '' });
  }

  findParentAtom(props = this.props) {
    if (!this.state.parentAtom && props.productTypeFilter && props.dealsFromList && props.dealFrom
       && props.productToLinkIdx !== undefined && props.productToLinkIdx !== null) {
      // eslint-disable-next-line
      const dealFromId = props.productTypeFilter.get(props.dealFrom);
      const hostDeal = props.dealsFromList.find(deal => deal.get('id') === dealFromId);
      const parentAtom = this.createParentAtom(props, hostDeal);
      if (parentAtom) {
        this.setState({ parentAtom });
      }
    }
  }

  createParentAtom(props, hostDeal) {
    // eslint-disable-next-line
      if (props.productTypeFilter && props.dealFrom){
      let atom = hostDeal;
      if (atom) {
        atom = atom
          .delete('products')
          .set('products', List.of(props.productTypeFilter));
      } else {
        atom = new Map()
          .set('products', List.of(this.props.productTypeFilter));
      }
      return (
        <Row
          style={{ position: 'fixed',
            padding: 'inherit',
            margin: 'inherit',
            right: props.dealFrom == 'sale' ? '3%' : '67%',
            width: '30%' }}
        >
          <Col xs={12}>
            <ElementBuilder
              data={atom}
              mode="parentatom"
              type={`connect${props.dealFrom}`}
              key="parentatom"
            />
          </Col>
        </Row>
      );
    }
    return undefined;
  }

  render() {
    const header = (<LinkHeader
      caption={'New link'}
      disabled={(this.state.step === 2 && !this.props.saveAllowed)
      || this.state.disabled}
      stepForward={this.stepForward}
      stepBack={this.stepBack}
    />);
    return (
      <MainComponentBox secondNavBar={header} withBreadcrumb wide>
        <Row>
          {this.state.step === 2 ?
            (<AtomsQuantity
              dealTo={this.props.dealTo}
              dealFrom={this.props.dealFrom}
              parentAtom={this.state.parentAtom}
              multiNodalQuantity={this.props.multiNodalQuantity}
            />)
            :
            (<Atoms
              dealTo={this.props.dealTo}
              dealFrom={this.props.dealFrom}
              handleSelected={this.handleSelected}
              handleStepBack={this.stepBack}
              alerts={this.alerts}
              mode="connect"
              filterBy={this.state.products}
              parentAtom={this.state.parentAtom}
            />)
          }
        </Row>
      </MainComponentBox>
    );
  }
}

AtomLinksEdit.propTypes = {
  selectedAtoms: React.PropTypes.object,
  saveSelectedAtoms: React.PropTypes.func.isRequired,
  connect: React.PropTypes.func,
  goBack: React.PropTypes.func,
  product: React.PropTypes.object,
  params: React.PropTypes.object,
  thisDeal: React.PropTypes.object,
  dealsToList: React.PropTypes.object,
  dealFrom: React.PropTypes.string,
  dealTo: React.PropTypes.string,
  productToLinkIdx: React.PropTypes.number,
  stopAtomsLinking: React.PropTypes.func.isRequired,
  saveAllowed: React.PropTypes.bool,
  dealsFromList: React.PropTypes.object,
  handleFormChanged: React.PropTypes.func,
  alterProduct: React.PropTypes.func,
  deliveryTerms: React.PropTypes.object,
  productTypeFilter: React.PropTypes.object,
  multiNodalQuantity: React.PropTypes.number,
  linkCreated: React.PropTypes.func,
};

export default connect((state, props) => ({
  selectedAtoms: state.getIn(['links', 'atoms', 'selected'], new Map()),
  product: state.getIn(['links', 'data', 'productToLinkIdx']) !== undefined
    ? state.getIn(['data', 'deals', 'deal', 'products'], new List())
      .get(state.getIn(['links', 'data', 'productToLinkIdx']), new Map())
    : new Map(),
  productToLinkIdx: state.getIn(['links', 'data', 'productToLinkIdx']),
  saveAllowed: state.getIn(['links', 'data', 'allowLinkSave'], true),
  dealsToList: state.getIn(['data', 'deals', 'list', props.dealTo]),
  deliveryTerms: state.getIn(['references', 'simple', DT_REF_PATH], new List()),
  productTypeFilter: state.getIn(['data', 'deals', 'deal', 'products'], new List())
    .get(state.getIn(['links', 'data', 'productToLinkIdx'])),
  dealsFromList: state.getIn(['data', 'deals', 'list', props.dealFrom]),
  data: state.getIn(['data', 'deals', 'list', props.dealTo]),
}),
(dispatch) => ({
  goBack() {
    goBack();
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  saveSelectedAtoms: (atoms) => {
    saveSelectedAtoms(dispatch, atoms);
  },
  alterProduct(idx, data) {
    alterProduct(dispatch, idx, data);
  },
  linkCreated(dealFrom, productIdx, links, allLinks) {
    linkCreated(dispatch, dealFrom, productIdx, links, allLinks);
  },
}))(AtomLinksEdit);
